export const qualityRegimeOptions = [
  {
    value: "IMBRO",
  },
  {
    value: "IMBRO/A",
  },
] as const;

export const qualityRegimeOptionsType = qualityRegimeOptions.map(({ value }) => value);
export type QualityRegimeOptions = (typeof qualityRegimeOptionsType)[number];
export const correctionReasonOptions = [
  {
    value: "bronhouder",
    label: "Bronhouder",
  },
  {
    value: "eigenCorrectie",
    label: "Eigen correctie",
  },
  {
    value: "inOnderzoek",
    label: "In onderzoek",
  },
  {
    value: "kwaliteitsregime",
    label: "Kwaliteitsregime",
  },
];
export const correctionReasonOptionsType = correctionReasonOptions.map(({ value }) => value);
export type CorrectionReasonOptions = (typeof correctionReasonOptionsType)[number];

export type BasicMetadata = {
  deliveryAccountableParty: string;
  qualityRegime: QualityRegimeOptions;
  projectNumber: string;
};

export interface BroIdMetadata extends BasicMetadata {
  broId: string;
}

export interface EditMetadata extends BasicMetadata {
  correctionReason: string;
  broId: string;
}
